import {
	RESET_STATE,
	FETCH_BUCKET_LIST,
	FETCH_INVENTORY_ITEMS,
	UPDATE_BUCKET_PRICE,
	UPDATE_BUCKET,
	UPDATE_BUCKETS,
	CLONE_BUCKET,
	UPDATE_STATUS,
	UPDATE_BUCKET_ORDER,
	DELETE_BUCKET,
	DELETE_INVENTORY,
	SET_UPLOAD_INVENTORY_FILE_ACTION,
	SET_UPLOAD_INVENTORY_FILE_BATCH,
	SET_CATEGORY_OPTIONS,
	SET_SUBCATEGORY_OPTIONS,
	SET_SUBSUBCATEGORY_OPTIONS,
	SET_MAPPED_SUPPLIER_OPTIONS,
	SET_MAPPED_DSO_OPTIONS,
	SET_PACKAGING_OPTIONS,
	SET_MANUFACTURER_OPTIONS,
	ACTION_LOGOUT_INITIATED,
	SET_PROCEDURES,
	SET_PROCEDURE_ENUMS,
	SET_DENTIRA_PRODUCT_NAME_TO_ID_MAP
} from '../actions/types';

const initialState = {
	inventory: {
		count: 0,
		items: [],
	},
	buckets: [],
	bucketItems: [],
	bucketOrder: [],
	showUploadInventoryFile: false,
	uploadInventoryFileAction: '',
	uploadInventoryFileBatch: '',
	uploadInventoryFileType: '',
	manufacturerOptions: [],
	supplierOptions: [],
	packagingOptions: [],
	mappedDSOOptions: [],
	categoryOptions: [],
	subCategoryOptions: [],
	subSubCategoryOptions: [],
	procedures: {},
	procedureEnums: {},
	proceduresToDentiraProductIdMap: {},
	dentiraProductIdToProceduresMap: {},
	dentiraProductIdToNameMap: {}
};

export default function (state = initialState, action) {
	let productList, bucketList;
	console.log(`%c${action.type}`, `color:green`);
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case FETCH_INVENTORY_ITEMS:
			return {
				...state,
				inventory: {
					count: action.payload.totalResults || 0,
					items: action.payload.products || [],
				},
			};

		case DELETE_INVENTORY:
			productList = state.inventory.items;
			for (let i = 0; i < productList.length; i++) {
				if (productList[i].supplier_product_id === action.payload.supplier_product_id) {
					productList[i] = { ...productList[i], ...action.payload };
					break;
				}
			}
			return {
				...state,
				inventory: {
					...state.inventory,
					items: productList,
				},
			};

		case UPDATE_STATUS:
			productList = state.inventory.items;
			for (let i = 0; i < productList.length; i++) {
				if (productList[i].supplier_product_id === action.payload.supplier_product_id) {
					productList[i] = { ...productList[i], ...action.payload };
					break;
				}
			}
			return {
				...state,
				inventory: {
					...state.inventory,
					items: productList,
				},
			};

		case FETCH_BUCKET_LIST:
			return {
				...state,
				bucketItems: action.payload,
				buckets: action.payload
			};

		case UPDATE_BUCKET_PRICE:
			productList = state.inventory.items;
			for (let i = 0; i < productList.length; i++) {
				if (productList[i].supplier_product_id === action.payload.supplier_product_id) {
					productList[i] = { ...productList[i], ...action.payload };
					break;
				}
			}
			return {
				...state,
				inventory: {
					...state.inventory,
					items: productList,
				},
			};

		case UPDATE_BUCKET:
			bucketList = state.bucketItems;
			for (let i = 0; i < bucketList.length; i++) {
				if (bucketList[i].id === action.payload.id) {
					bucketList[i] = { ...bucketList[i], ...action.payload };
					break;
				}
			}
			return {
				...state,
				bucketItems: bucketList,
				buckets: (state.buckets || []).map((bucket) => {
					if(bucket.id === action.payload.id){
						return {...bucket, ...action.payload}
					}
					return bucket;
				})
			};

		case UPDATE_BUCKETS:
			return {
				...state,
				buckets: action.payload
			}

		case UPDATE_BUCKET_ORDER:
			return {
				...state,
				bucketOrder: action.payload,
			};

		case CLONE_BUCKET:
			bucketList = state.bucketItems;
			bucketList.push(action.payload);
			return {
				...state,
				bucketItems: bucketList,
				buckets: [action.payload, ...state.buckets]
			};

		case DELETE_BUCKET:
			bucketList = [];
			for (let i = 0; i < state.bucketItems.length; i++) {
				if (state.bucketItems[i].id !== action.payload.id) {
					bucketList.push(state.bucketItems[i]);
				}
			}
			return {
				...state,
				bucketItems: bucketList,
				buckets: (state.buckets || []).filter((bucket) => (bucket.id !== action.payload.id))
			};

		case SET_UPLOAD_INVENTORY_FILE_ACTION:
			const showUploadInventoryFile = action.payload.showUploadInventoryFile || false;
			const uploadInventoryFileType = action.payload.uploadInventoryFileType || '';
			const uploadInventoryFileAction = action.payload.uploadInventoryFileAction || '';
			return {
				...state,
				showUploadInventoryFile,
				uploadInventoryFileType,
				uploadInventoryFileAction,
			};

		case SET_UPLOAD_INVENTORY_FILE_BATCH:
			const uploadInventoryFileBatch = action.payload.uploadInventoryFileBatch || '';
			return {
				...state,
				uploadInventoryFileBatch,
			};

		case SET_MANUFACTURER_OPTIONS:
			let manufacturerOptions = action.payload || [];
			return {
				...state,
				manufacturerOptions,
			};

		case SET_MAPPED_SUPPLIER_OPTIONS:
			let mappedSupplierOptions = action.payload || [];
			return {
				...state,
				mappedSupplierOptions,
			};

		case SET_PACKAGING_OPTIONS:
			let packagingOptions = action.payload || [];
			return {
				...state,
				packagingOptions,
			};

		case SET_MAPPED_DSO_OPTIONS:
			let mappedDSOOptions = action.payload || [];
			return {
				...state,
				mappedDSOOptions,
			};

		case SET_CATEGORY_OPTIONS:
			let categoryOptions = action.payload || [];
			return {
				...state,
				categoryOptions,
			};

		case SET_SUBCATEGORY_OPTIONS:
			let subCategoryOptions = action.payload || [];
			return {
				...state,
				subCategoryOptions,
			};

		case SET_SUBSUBCATEGORY_OPTIONS:
			let subSubCategoryOptions = action.payload || [];
			return {
				...state,
				subSubCategoryOptions,
			};
		
		case ACTION_LOGOUT_INITIATED:
			return initialState;	

		case SET_PROCEDURES:
			let {procedures, proceduresToDentiraProductIdMap, dentiraProductIdToProceduresMap} = action.payload || {};

			return {
				...state,
				procedures,
				proceduresToDentiraProductIdMap,
				dentiraProductIdToProceduresMap
			}

		case SET_PROCEDURE_ENUMS:
			let procedureEnums = action.payload || {};
			return {
				...state,
				procedureEnums
			}

		case SET_DENTIRA_PRODUCT_NAME_TO_ID_MAP:
			let dentiraProductIdToNameMap = action.payload || {};
			return {
				...state,
				dentiraProductIdToNameMap
			}

		default:
			return state;
	}
}
